import { render } from "./Facebook.vue?vue&type=template&id=0d4e32be"
import script from "./Facebook.vue?vue&type=script&lang=js"
export * from "./Facebook.vue?vue&type=script&lang=js"
script.render = render

export default script